var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4327 35.9432H17.8243V18.6052H12.4327V35.9432Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.1214C12 14.8453 13.3975 16.2428 15.1285 16.2428C16.8524 16.2428 18.2499 14.8382 18.2499 13.1214C18.2499 11.3975 16.8524 10 15.1285 10C13.3975 10 12 11.3975 12 13.1214Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6156 35.9432H38V26.43C38 21.7621 36.9926 18.1724 31.5372 18.1724C28.9195 18.1724 27.1602 19.6126 26.4437 20.9746H26.3727V18.6052H21.2082V35.9432H26.5855V27.3735C26.5855 25.1105 27.0112 22.9184 29.8134 22.9184C32.5801 22.9184 32.6156 25.5078 32.6156 27.5154V35.9432Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.41b61c98.svg";
export { ForwardRef as ReactComponent };